module.exports = __webpack_public_path__ + "img/5.d7d7b2a3.png";